import React, { useState, useEffect } from 'react';
import { FaArrowDown, FaArrowUp, FaBullhorn, FaPiggyBank, FaNewspaper, FaChartBar, FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import '../styles/home.css'; // Updated import path
import { MdOutlineSupportAgent, MdOutlineInfo } from "react-icons/md";
import Slider from 'react-slick'; // Import Slider component
import 'slick-carousel/slick/slick.css'; // Import slick carousel styles
import 'slick-carousel/slick/slick-theme.css'; // Import slick theme styles
import allPriceImage from '../assets/all_price.jpg'; // Import first image
import cryptoImage from '../assets/cryptocurrency.jpg'; // Import second image
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

function Home() {

  const [cryptoData, setCryptoData] = useState([]);
  const [forexData, setForexData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("crypto");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [isBalanceVisible, setIsBalanceVisible] = useState(true); // State to toggle visibility
  const [userData, setUserData] = useState(null);
  const [activeNav, setActiveNav] = useState('/');

  const toggleBalanceVisibility = () => {
    setIsBalanceVisible((prev) => !prev);
  };

  // Slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const fetchCryptoData = async () => {
    try {
      const response = await fetch('https://api.coingecko.com/api/v3/coins/markets?ids=bitcoin,ethereum,solana,cardano,xrp,dogecoin,matic-network,shiba-inu,avalanche-2&vs_currency=usd');
      const data = await response.json();

      const formattedData = data.map(coin => ({
        pair: `${coin.symbol.toUpperCase()}USD`,
        lastPrice: coin.current_price,
        change: coin.price_change_percentage_24h,
        icon: coin.image
      }));

      setCryptoData(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching crypto data:', error);
      setIsLoading(false);
    }
  };

  // Fetch Forex Data (using Frankfurter API)
  const fetchForexData = async () => {
    try {
      const response = await fetch('https://api.frankfurter.app/latest?from=USD');
      const data = await response.json();
      const forexPairs = ['EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'CNH', 'THB'];

      const formattedData = forexPairs.map(pair => {
        const lastPrice = data.rates[pair];

        return {
          pair: `${pair}USD`,
          lastPrice: lastPrice ? Number(lastPrice) : 0,
          change: lastPrice ? Number((Math.random() * 2 - 1).toFixed(2)) : 0,
        };
      });

      setForexData(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching forex data:', error);
      setIsLoading(false);
    }
  };

  // Fetch User Balance
  const fetchUserBalance = async (username) => {
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${baseUrl}/wallet/username/${username}`);
      const data = await response.json();

      if (data && data.amount !== undefined) {
        setUserData(prev => ({ ...prev, amount: data.amount })); // Store the correct amount
      }
    } catch (error) {
      console.error('Error fetching user balance:', error);
    }
  };


  // Fetch Crypto Data (using Coingecko API)
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setUserData(user);
      fetchUserBalance(user.username);
    }
    fetchCryptoData();
    fetchForexData();

    // Refresh data every minute for real-time updates
    const interval = setInterval(() => {
      fetchCryptoData();
      fetchForexData();
    }, 6000); // Refresh every minute

    return () => clearInterval(interval);
  }, []);
  const displayedData = selectedTab === "crypto" ? cryptoData : forexData;

  return (
    <div className="home-page">
      {/* Account Balance Section */}
      <div className="account-balance">
        <div className="balance-header">
          <span style={{ display: 'flex', alignItems: 'center' }}>Overall Account Balance (US-Dollar)
            {isBalanceVisible ? (
              <FaRegEye className="eye-icon" onClick={toggleBalanceVisibility} />
            ) : (
              <FaRegEyeSlash className="eye-icon" onClick={toggleBalanceVisibility} />
            )}
          </span>

          <button className="deposit-button" onClick={() => navigate('/deposit')}>DEPOSIT</button>
        </div>

        {isBalanceVisible ? (
          <>
            <h1>{isBalanceVisible ? `$${userData?.amount?.toFixed(2) || "0.00"}` : "********"}</h1>
            <p>{isBalanceVisible ? `$${userData?.amount?.toFixed(2) || "0.00"}` : "********"}</p>

          </>
        ) : (
          <h1>********</h1> // Single ******** for both h1 and p
        )}

      </div>

      {/* Action Buttons Section */}
      <div className="quick-actions">
        <div className="action-container">
          <div className="action-item">
            <Link
              to="/deposit"
              className={`nav-item ${activeNav === '/deposit' ? 'active' : ''}`}
              onClick={() => setActiveNav('/deposit')}
            >
              <FaArrowDown className="action-icon" />
            </Link>
          </div>
          <span>Deposit</span>
        </div>
        <div className="action-container">
          <div className="action-item">
            <Link
              to="/widthdrawall"
              className={`nav-item ${activeNav === '/widthdrawall' ? 'active' : ''}`}
              onClick={() => setActiveNav('/widthdrawall')}
            >
              <FaArrowUp className="action-icon" />
            </Link>
          </div>
          <span>Withdraw</span>
        </div>
        <div className="action-container">
          <div className="action-item">
            <Link
              to="/staking"
              className={`nav-item ${activeNav === '/staking' ? 'active' : ''}`}
              onClick={() => setActiveNav('/staking')}
            >
              <FaPiggyBank className="action-icon" />
            </Link>
          </div>
          <span>DeFi Staking</span>
        </div>
        <div className="action-container">
          <div className="action-item">
          <Link
              to="/news"
              className={`nav-item ${activeNav === '/news' ? 'active' : ''}`}
              onClick={() => setActiveNav('/news')}
            >
            <FaNewspaper className="action-icon" />
            </Link>
          </div>
          <span>News</span>
        </div>
        <div className="action-container">
          <div className="action-item">
            <Link
              to="/market"
              className={`nav-item ${activeNav === '/market' ? 'active' : ''}`}
              onClick={() => setActiveNav('/market')}
            >
              <FaChartBar className="action-icon" />
            </Link>
          </div>
          <span>Market</span>
        </div>
        <div className="action-container">
          <div className="action-item">
            <MdOutlineSupportAgent className="action-icon" />
          </div>
          <span>Live Chat</span>
        </div>
        <div className="action-container">
          <div className="action-item">
            <Link
              to="/about"
              className={`nav-item ${activeNav === '/about' ? 'active' : ''}`}
              onClick={() => setActiveNav('/about')}
            >
              <MdOutlineInfo className="action-icon" />
            </Link>
          </div>
          <span>About</span>
        </div>
      </div>

      {/* News Section with Slider */}
      <div className="home-section">
        <Slider {...sliderSettings}>
          <div className="home-card">
            <div className="card-content">
              <div className="text-column">
                <h3>Crypto Price since All Time High (ATH)</h3>
                <p>Browse cryptocurrency price change since all time high.</p>
              </div>
              <div className="image-column">
                <div className="home-image">
                  <img src={allPriceImage} alt="Crypto Price ATH" />
                </div>
              </div>
            </div>
          </div>
          <div className="home-card">
            <div className="card-content">
              <div className="text-column">
                <h3>The Impact of Cryptocurrency on the Tech Industry</h3>
                <p>Cryptocurrency, a decentralized digital currency, has become a transformative force...</p>
              </div>
              <div className="image-column">
                <div className="home-image">
                  <img src={cryptoImage} alt="Cryptocurrency Impact" />
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>


      {/* Price Section */}
      <div className="price-section">
        <div className="price-card">
          <FaBullhorn style={{ marginRight: '10px' }} />
          <p>Celebrating the 9th anniversary of the establish...</p>
        </div>
        <hr />
        <div className="coins-container">
          {/* Tab Navigation */}
          <div className="tab-container">
            <button
              className={`tab-button ${selectedTab === "crypto" ? "active" : ""}`}
              onClick={() => setSelectedTab("crypto")}
            >
              Crypto
            </button>
            <button
              className={`tab-button ${selectedTab === "forex" ? "active" : ""}`}
              onClick={() => setSelectedTab("forex")}
            >
              Forex
            </button>
          </div>

          {/* Data Table */}
          <div className="table-container">
            {isLoading ? (
              <p className="loading">Loading...</p>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Pair</th>
                    <th style={{ color: "black", textAlign: "center" }}>Last Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedTab === "favorite" ? (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                        No favorites added yet.
                      </td>
                    </tr>
                  ) : (
                    displayedData.map((item) => (
                      <tr key={item.pair}>
                        <td style={{ color: "red", textAlign: "left" }}>
                          <div className="pair-container" style={{ display: "flex", alignItems: "start" }}>
                            {selectedTab === "crypto" ? (
                              <img
                                src={item.icon}
                                alt={item.pair}
                                className="pair-icon"
                                onError={(e) => {
                                  console.error('Icon load error:', e);
                                  e.target.src = "/icons/default.png";
                                }}
                              />
                            ) : (
                              <img
                                src={`https://flagcdn.com/w40/${item.pair.slice(0, 3).toLowerCase()}.png`}
                                alt={item.pair}
                                className="pair-icon"
                                onError={(e) => {
                                  console.error('Flag load error:', e);
                                  const fallbackCodes = {
                                    'eur': 'eu',
                                    'gbp': 'gb',
                                    'jpy': 'jp',
                                    'aud': 'au',
                                    'cad': 'ca',
                                    'cnh': 'cn',
                                    'thb': 'th',
                                  };
                                  const code = item.pair.slice(0, 3).toLowerCase();
                                  e.target.src = fallbackCodes[code]
                                    ? `https://flagcdn.com/w40/${fallbackCodes[code]}.png`
                                    : "/icons/default.png";
                                }}
                              />
                            )}
                            <div>{item.pair}</div>
                          </div>
                        </td>
                        <td style={{ color: "black", textAlign: "center" }}>
                          ${item.lastPrice ? item.lastPrice.toFixed(5) : "0.00000"}
                        </td>
                        <td>
                          <div
                            className={item.change < 0 ? "negative" : "positive"}
                            style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}
                          >
                            {item.change.toFixed(2)}%
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
}

export default Home;